module.exports = __webpack_public_path__ + "img/taxi.5bd1b65c.svg";